/**
 * @param {HTMLElement|Document} section
 * @param {string} selector
 */
const getSection = (section, selector) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(section, 'text/html');

  if (selector) {
    return doc.querySelector(selector);
  }

  return doc;
};

export default getSection;
